import styled from 'styled-components';
import { UncontrolledPopover } from 'reactstrap';

import { colors, fontSizes, fonts, device } from 'shared/defaultTheme';
import { TextField } from 'shared/components/form/Inputs';
import BackgroundBox from 'shared/components/BackgroundBox';
import { Modal } from 'shared/components/modal/Modals';

export const SerachClientsForm = styled.div`
  width: 100%;
  margin-left: -17px;
`;

export const SerachClients = styled(TextField)`
  margin-top: 6px !important;
  width: 100% !important;
  input {
    color: ${colors.gullGrey};
    font-size: ${fontSizes.sm}px;
    letter-spacing: 0;
    line-height: 18px;
  }
`;

export const SearchContacts = styled(TextField)`
  width: 100% !important;
  input {
    color: ${colors.black};
    font-size: ${fontSizes.sm}px;
    letter-spacing: 0;
    line-height: 18px;
  }
`;

export const SearchDiv = styled.div`
  width: 100%;
  padding-top: 7px;
  justify-content: space-between;
  @media ${device.sm} {
    padding-left: 0;
  }
  @media ${device.md} {
    padding-left: 0;
  }
  @media ${device.lg} {
    padding-left: 0;
  }
  @media ${device.xl} {
    padding-left: 20px;
  }
`;

export const H6 = styled.h6(() => ({
  paddingLeft: '12px',
  paddingTop: '15px',
}));

export const Hr = styled.hr`
  @media ${device.sm} {
    width: 100%;
  }
  @media ${device.md} {
    width: 100%;
  }
  @media ${device.lg} {
    width: 100%;
  }
  @media ${device.xl} {
    width: 90%;
  }
`;

export const PublicDocumentsWrapper = styled.div`
  padding: 0 30px;
  padding-bottom: 0;

  .required-mark {
    color: ${colors.error};
  }

  .public-data-container {
    position: relative;
    left: 1.3rem;
  }

  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .sub-title {
    font-family: ${fonts.default};
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 19px;
    color: ${colors.black};
  }
  .container-public {
    width: 88%;
  }
  .upload-name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 190px;
    flex: 1 1 auto;
  }
  .custom-control {
    min-height: 0;
  }
  .e-multiselect {
    input::placeholder {
      position: relative;
      left: 8px;
      top: 4px;
    }
  }
  .list-public-container {
    min-height: auto;
    max-height: 315px;
    overflow: auto;
  }
`;

export const NotifiFormWrapper = styled.div`
  padding: 0 20px;
  padding-bottom: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .row-content {
    padding: 0;
    .col-sm-12 {
      padding: 0;
    }
  }
  .form-field {
    margin-top: 26px;
    .required-mark {
      color: ${colors.error};
    }
    .row {
      padding: 0;
      margin-right: 0;
      margin-left: 0;
    }
  }
  .row-border-bottom {
    border-bottom: 1px solid ${colors.spanishGray};
    padding-bottom: 10px !important;
    margin-bottom: 24px;
  }
  .button-icon {
    background-color: ${colors.transparent};
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: ${fontSizes.md}px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: auto;

    &:active {
      opacity: 0.5;
    }
  }
`;

export const ShareDocumentContactsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .form-container {
    height: 620px;
    overflow: auto;
  }
  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .client-name-box {
    height: 37px;
    background-color: ${colors.whiteSmoke};
    padding: 8px;
    strong {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .document-select-all-client {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 16px;
  }
  .list-contact {
    color: ${colors.zambezi};
    font-family: ${fonts.roboto};
    font-size: 13px;
    letter-spacing: 0;
    line-height: 25px;
  }
  .contact-box-container {
    box-sizing: border-box;
    border: 1px solid ${colors.pattens};
    border-radius: 4px;
    height: 244px;
    overflow: auto;
    .search-contacts-container {
      height: 36px;
      border-radius: 4px 4px 0 0;
      background-color: ${colors.whiteSmoke};
    }
  }
  .search-contacts-form {
    width: 100%;
    .form__form-group-field {
      border: none;
      &:focus,
      &:active {
        border: none;
      }
    }
  }
`;

export const DocumentDetailBackground = styled(BackgroundBox)`
  flex: 0 0 90%;
`;

export const H3 = styled.h3`
  color: ${colors.black} !important;
  font-family: ${fonts.default} !important;
  font-size: ${fontSizes.lg} !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 21px !important;
  margin-bottom: 35px;
`;

export const ContainerIcon = styled.div`
  flex: 0 0 3%;
  margin-right: 10px;
  margin-left: 10px;
`;

export const H5 = styled.h5`
  color: ${colors.black} !important;
  font-family: ${fonts.default};
  font-size: ${fontSizes.lg}px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
`;

export const DocumentDetailCardH6 = styled.h6`
  color: ${colors.black} !important;
  font-family: ${fonts.default};
  font-size: ${fontSizes.sm}px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 5px;
  padding-left: 10px;
`;

export const BackgroundTitle = styled.div`
  border-radius: 2px;
  background-color: ${colors.pattens};
  align-items: center;
  height: 34px;
  margin-bottom: 15px;
`;

export const DocumentDetailCardHr = styled.hr`
  margin-bottom: 30px;
  box-sizing: border-box;
  border: 1px solid ${colors.pattens};
`;

export const Ul = styled.ul`
  overflow: auto;
  @media ${device.sm} {
    height: 300px;
  }
  @media ${device.md} {
    height: 300px;
  }
  @media ${device.lg} {
    height: 300px;
  }
  @media ${device.xl} {
    height: 720px;
  }
`;

export const UploadDocumentClientsWrapper = styled.div`
  .upload-document-title {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
  }
  .upload-document-box {
    box-sizing: border-box;
    height: 644px;
    width: 100%;
    border: 1px solid ${colors.gullGrey};
    .upload-document-form-container {
      padding: 25px;
      height: 92%;
      .destination-button {
        margin-top: 24px;
        cursor: pointer;
        text-transform: uppercase;
        width: 100%;
      }
      .upload-document-drag-drop {
        width: 37%;
      }
      .upload-document-files {
        width: 70%;
        display: grid;
        grid-template-rows: 4% 2% 86%;
        h5 {
          color: rgba(0, 0, 0, 0.99);
          font-family: ${fonts.default};
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 15px;
        }
        span {
          color: rgba(0, 0, 0, 0.99);
          font-family: ${fonts.default};
          font-size: 14px;
          font-weight: bold;
          letter-spacing: 0;
          line-height: 16px;
          text-align: center;
        }
        .upload-document-public-text {
          color: ${colors.black};
          font-family: ${fonts.default};
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 19px;
        }
        .document-all-file-text {
          color: ${colors.black};
          font-family: ${fonts.default};
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 15px;
        }
      }
      .upload-document-divider {
        height: 5px;
        width: auto;
        background-color: ${colors.pattens};
      }
    }
    .action-container {
      height: auto;
      display: flex;
      width: 100%;
      justify-content: flex-end;
      align-items: flex-end;
      .button-action {
        height: 28px;
      }
    }
  }
`;

export const ScrollAttach = styled.div`
  overflow-y: auto;
  max-height: 480px;
`;

export const DivFileNameAttachForm = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  @media ${device.sm} {
    width: 120px;
    flex: 1 1 auto;
  }
  @media ${device.md} {
    width: 180px;
    flex: 1 1 auto;
  }
  @media ${device.lg} {
    width: 200px;
    flex: 1 1 auto;
  }
  @media ${device.xl} {
    width: 200px;
    flex: 1 1 auto;
  }
`;

export const Popover = styled(UncontrolledPopover)`
  .popover {
    width: auto;
    border: none;
    box-shadow: 0 0 4px 0 #d6d8d9;
    .popover-body {
      padding: 0;
    }
  }
  .popover .arrow::before,
  .popover .arrow::after {
    border-style: none;
  }
`;

export const OptionMenu = styled.div`
  width: 208px;
  cursor: pointer;
  padding: 12px;
  .filter-name {
    color: ${colors.black};
    font-family: ${fonts.roboto};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 15px;
  }
  .filter-i18-name {
    color: ${colors.suvaGrey};
    font-family: ${fonts.roboto};
    font-size: 13px;
    letter-spacing: 0;
    line-height: 18px;
  }
`;

export const SelectCustomFolderModal = styled(Modal)`
  top: 20%;
  .modal-header {
    border: 0;
    height: 11px;
    padding-top: 0px;
    padding-bottom: 0;
    padding-right: 0px;
    svg {
      fill: #898989 !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
  .modal-content {
    border-radius: 4px;
    padding: 30px 22.5px 30px 22.5px;
    height: auto;
    .title {
      color: #000000;
      font-family: MTTMilano;
      font-size: 20px;
      font-weight: bold;
      -webkit-letter-spacing: 0;
      -moz-letter-spacing: 0;
      -ms-letter-spacing: 0;
      letter-spacing: 0;
      line-height: 24px;
    }
    .title-wrapper {
      border-bottom: 1px solid #000000;
      padding-bottom: 15px;
      width: 100%;
    }
  }
`;

export const CustomFolderTreeWrapper = styled.div`
  border: none;
  border-bottom: 1px solid ${colors.lightSilver};
  border-top: 1px solid ${colors.lightSilver};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: ${({ level }) => 5 * level + 5}px;
  width: 100%;
  position: relative;
  .info-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    .folder-icon {
      height: 15px;
      width: 15px;
      fill: ${colors.black};
    }
    span {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 16px;
    }

    .text-file {
      padding-left: 5px;
    }

    .text-folder {
      margin-top: 5px;
      margin-left: 6px;
    }
  }
  .form-check-input {
    position: initial;
    margin-top: 0;
    margin-left: 0;
  }
  .caret {
    fill: ${colors.black};
    height: 16px;
    width: 16px;
    padding-left: 4px;
    right: 20px;
    position: absolute;
    polygon {
      fill: ${colors.black};
    }
  }

  .actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    button {
      background-color: transparent;
      border: none;
      :active {
        opacity: 0.5;
      }
    }
    svg {
      height: 21px;
      width: 17px;
      fill: ${colors.suvaGrey};
    }
  }
`;

export const CustomFoldersDataWrapper = styled.div`
  border-top: 1px solid ${colors.pattens};
  display: flex;
  flex: 0.9;
  flex-direction: column;
  margin-top: 16px;
  width: 100%;
  .search-folder-container {
    margin-bottom: 20px;
    .search-folder-input {
      background-color: ${colors.whiteSmoke};
      border-right: unset;
      border-left: unset;
    }
  }
  .action-buttons {
    margin-top: 30px;
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .custom-folder-tree {
    padding-bottom: 70px;
    border-bottom: 1px solid ${colors.pattens};
    max-height: 300px;
    overflow: auto;
  }
`;

export const RadioInput = styled.input`
  appearance: none;
  width: 13px;
  height: 13px;
  padding: 2px !important;
  background-clip: content-box;
  border: 1px solid ${colors.black};
  border-radius: 50%;
  margin-right: 8px;
  &:checked {
    background-color: ${colors.black};
  }
  &:disabled {
    cursor: not-allowed;
  }
`;

export const SelectedFolderWrapper = styled.div`
  border: none;
  border-bottom: 1px solid ${colors.lightSilver};
  border-top: 1px solid ${colors.lightSilver};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0px;
  margin-top: 10px;
  width: 100%;
  .info-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .folder-info {
      display: flex;
      align-items: flex-end;
    }
    .folder-icon {
      height: 20px;
      fill: ${colors.black};
      margin-right: 8px;
    }
    span {
      color: ${colors.dimGray};
      font-family: ${fonts.default};
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 16px;
    }
  }
  .trash-icon {
    fill: ${colors.suvaGrey};
    height: 16px;
    width: 16px;
    cursor: pointer;
  }
`;
